import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const StudentElearn = lazy(() => import('./StudentElearn'));

const StudentElearnModule: React.FC = () => {
  return (
    <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
      <Routes>
        <Route path="" element={<StudentElearn />} />
      </Routes>
    </Suspense>
  );
};

export default StudentElearnModule;
